<template>
  <div class="waitingcallMessage waitingcallResult notranslate">
    <div v-if="!activate">
      <div class="title mb30">
        <h3>{{ locale.waitingcall }}</h3>
        <p class="colorGrey">{{ locale.ask_front }}</p>
        <h2>{{ locale.inactive_service }}</h2>
      </div>
      <div class="formBox">
        <div class="formGroup">
            <button
              type="button"
              class="btn btnRound btnWhite"
              @click="refresh">
              {{ locale.refresh }}
            </button>
          </div>
      </div>
    </div>
    <div v-else-if="availableTime">
      <button
        type="button"
        class="btnEntrance"
        @click.stop="toEntrancePage()">
      </button>
      <div class="title mb30">
        <h3>{{ locale.not_available_time }}</h3>
        <p class="colorGrey">{{ locale.available_service_time }}</p>
        <h2>{{ time.start }} ~ {{ time.end }}</h2>
      </div>
      <div class="formBox">
        <div class="formGroup">
            <button
              type="button"
              class="btn btnRound btnWhite"
              @click="refresh">
              {{ locale.refresh }}
            </button>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'ln',
    'locale',
    'isPublic',
    'info',
    'availableTime',
    'activate'
  ],
  computed: {
    entranceActive () {
      return this.info && this.info.setting && this.info.setting.entranceActive
    },
    time () {
      const startTime = this.availableTime && this.availableTime.startTime
      const endTime = this.availableTime && this.availableTime.endTime
      return {
        start: this.numToTimeFormat(startTime),
        end: this.numToTimeFormat(endTime)
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    toEntrancePage () {
      const entranceActive = this.entranceActive
      if (entranceActive) {
        const entranceUrl = this.info && this.info.setting && this.info.setting.entranceUrl
        this.$router.push({
          name: 'page',
          params: {
            ln: this.$route.params.ln,
            id: entranceUrl.pageId
          }
        })
      } else {
        this.$router.push({
          name: 'waitingcallNationality'
        })
      }
    },
    numToTimeFormat (num) {
      return `${num.slice(0, 2)}:${num.slice(2, 4)}`
    },
    refresh () {
      this.$emit('refresh')
    }
  }
}
</script>

